<template>
	<div class="checkOrderLeft">
		<div class="liftDetail">
			<h6>电梯信息</h6>
			<p>
				<span>使用单位</span>
				<span>{{ detail.lift.propertyUnitName }}</span>
			</p>
			<p>
				<span>项目名称</span>
				<span>{{ detail.lift.projectName }}</span>
			</p>
			<p>
				<span>电梯位置</span>
				<span>{{ detail.lift.liftLocation }}</span>
			</p>
		</div>
		<div class="maintenanceDetail">
			<h6>保养信息</h6>
			<p>
				<span>工单编号</span>
				<span>{{ detail.orderNo }}</span>
			</p>
			<p>
				<span>维保人员</span>
				<span>{{ detail.operatorUserName }}</span>
			</p>
			<!-- <p>
        <span>保养类型</span>
        <span>{{ detail.maintainTypeName }}</span>
      </p> -->
			<p>
				<span>年检结果</span>
				<span>{{ detail.annualInspectionResult }}</span>
			</p>
			<p>
				<span>故&nbsp;障&nbsp;&nbsp;点</span>
				<!-- <span>{{ detail.faultPointResultDTOList | faultPointResultDTOListFilter }} </span> -->
				<span>{{ list | faultPointResultDTOListFilter }} </span>
			</p>
			<p>
				<span>解决方案</span>
				<span>{{ detail.solution }}</span>
			</p>
			<p>
				<span>备注信息</span>
				<span>{{ detail.remark }}</span>
			</p>
			<p>
				<span>更换配件</span>
				<span>{{ detail.replacementParts }}</span>
			</p>
		</div>
		<div>
			<div class="maintenanceBox">
				<p>
					<i>状态：</i><i>{{ detail.statusName }},</i>
				</p>
				<p>
					<i>耗时：</i><i>{{ formatSeconds(detail.elapsedTime) }}</i>
				</p>
			</div>
			<!-- <el-table :data="detail.logList" style="width: 100%" max-height="200px">
				<el-table-column prop="statusName" label="状态" width="70">
				</el-table-column>
				<el-table-column prop="createTime" label="时间" width="150">
				</el-table-column>
				<el-table-column prop="address" label="操作位置" show-overflow-tooltip>
				</el-table-column>
				<el-table-column
					prop="distance"
					width="100"
					label="与目标距离"
					show-overflow-tooltip
				>
				</el-table-column>
			</el-table> -->
		</div>
	</div>
</template>

<script>
export default {
	props: {
		detail: {
			type: Object,
			default: () => {
				return {
					lift: {},
				};
			},
		},
	},
	data() {
		return {
			list: [
				{
					firstId: null,
					firstName: null,
					secondId: null,
					secondName: null,
					thirdId: 10,
					thirdName: "门锁",
				},
				{
					firstId: null,
					firstName: null,
					secondId: null,
					secondName: null,
					thirdId: 13,
					thirdName: "门扇",
				},
				{
					firstId: null,
					firstName: null,
					secondId: null,
					secondName: null,
					thirdId: 15,
					thirdName: "其他",
				},
				{
					firstId: null,
					firstName: null,
					secondId: null,
					secondName: null,
					thirdId: 18,
					thirdName: "补偿链",
				},
			],
		};
	},
	methods: {
		formatSeconds(value) {
			if (!value) {
				return "";
			}
			var theTime = parseInt(value); // 秒
			var middle = 0; // 分
			var hour = 0; // 小时

			if (theTime > 60) {
				middle = parseInt(theTime / 60);
				theTime = parseInt(theTime % 60);
				if (middle > 60) {
					hour = parseInt(middle / 60);
					middle = parseInt(middle % 60);
				}
			}
			var result = "" + parseInt(theTime) + "秒";
			if (middle > 0) {
				result = "" + parseInt(middle) + "分" + result;
			}
			if (hour > 0) {
				result = "" + parseInt(hour) + "小时" + result;
			}
			return result;
		},
	},
	filters: {
		faultPointResultDTOListFilter(list) {
			console.log(list);
			if (!list) {
				return;
			}
			let str = "";
			list.forEach((item, index) => {
				let sss = "";
				if (index === list.length - 1) {
					sss = `${
						item.firstName && (item.secondName || item.thirdName)
							? item.firstName + "-"
							: item.firstName || ""
					}${
						item.secondName
							? item.thirdName
								? item.secondName + "-"
								: item.secondName || ""
							: ""
					}${item.thirdName ? item.thirdName : ""}`;
				} else {
					sss = `${
						item.firstName && (item.secondName || item.thirdName)
							? item.firstName + "-"
							: item.firstName || ""
					}${
						item.secondName
							? item.thirdName
								? item.secondName + "-"
								: item.secondName || ""
							: ""
					}${item.thirdName ? item.thirdName : ""},`;
				}
				str += sss;
			});
			return str;
		},
	},
};
</script>

<style lang="scss">
.checkOrderLeft {
	.liftDetail {
		font-size: 14px;
		p:last-child {
			margin-bottom: 23px;
		}
	}
	p {
		display: flex;
		margin-bottom: 16px;
		span:first-child {
			margin-right: 20px;
		}
		span:last-child {
			color: #999999;
		}
	}
	h6 {
		color: #333333;
		position: relative;
		font-size: 14px;
		margin-bottom: 23px;
		&::before {
			position: absolute;
			content: " ";
			width: 4px;
			height: 14px;
			background: #0092ff;
			top: 2px;
			left: -8px;
		}
	}
	.maintenanceBox {
		display: flex;
		i {
			font-style: normal;
		}
		p {
			margin-right: 20px;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/AnnualInspection/components2/CheckOrderLeft.vue